import PropTypes from 'prop-types';
import classNames from 'classnames';
import { has, isEmpty } from 'lodash';
import Icon from '../../Icon/Icon';
import getIcon from '../utils/getIcon';

const ServiceType = ({
  serviceType,
  level,
  showIcon,
  iconColor
}) => {
  const itemClass = () => classNames({
    'mb-4 text-purple px-4 inline-block font-heavy-font': level <= 0,
    'mb-1.5 text-text-blue font-regular-font': level > 0,
  });

  return (
    <li className={itemClass()}>
      <div className="flex">
        {
          showIcon &&
            <span className="pl-6 mr-2 flex items-center">
              <Icon icon={getIcon(serviceType.code)} color={iconColor} size={18} />
            </span>
        }
        <span>
          {serviceType.name}
        </span>
      </div>
      {
        has(serviceType, 'children') && !isEmpty(serviceType.children) &&
          <ul className="my-1.5 list-disc">
            {
              serviceType.children.map(st => (
                <ServiceType
                  key={`app-components-service-type-${level}-${st.code}`}
                  serviceType={st}
                  level={level + 1}
                  showIcon={false}
                  iconColor={iconColor}
                />
              ))
            }
          </ul>
      }
    </li>
  );
};

ServiceType.propTypes = {
  iconColor: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  serviceType: PropTypes.shape({
    children: PropTypes.array,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  showIcon: PropTypes.bool.isRequired,
};

export default ServiceType;
